export default {
  methods: {
    isRequestLoading(requestId) {
      return this.$store.getters.isRequestLoading(requestId);
    },
  },
};
